export default __webpack_public_path__ + "static/Wolfsburg_Kuball_Trailer_210507_3_720p-da823eedb803b875e760e649a6745e9a.mp4";